<script lang="ts">
  import { t } from '$lib/translations'
  import type { TabItem } from '$lib/types'
  import { twMerge } from 'tailwind-merge'

  let containerClasses = ''
  export let items: TabItem[] = []
  export let activeTabValue = 1
  export { containerClasses as class }
  export let isStickyActive = false

  const handleClick = (tabValue: number) => () => (activeTabValue = tabValue)
</script>

<div class={containerClasses}>
  <ul class={twMerge('flex flex-row gap-2 transition-all h-[64px]', isStickyActive ? 'lg:h-0 lg:opacity-0' : '')}>
    {#each items as item}
      <li class={twMerge('bg-cs-light-gray mb-2 w-full lg:w-fit hover:cursor-pointer', activeTabValue === item.value ? 'bg-alsa-gray mb-0 text-white' : '', !item.showMobile ? 'hidden lg:flex' : 'flex')}>
        <button
          class="p-4 flex flex-col lg:flex-row w-full h-full gap-1 text-center  justify-center items-center uppercase font-normal lg:text-[1rem] text-[0.8rem]" data-test-id={'tab-'+item.value}
          on:click={handleClick(item.value)}
        >
          <span class ="hidden lg:flex">
            {#if item.labelIcon}
            <svelte:component this={item.labelIcon} />
            {/if}
          </span>
          {$t(item.label)}
        </button>
      </li>
    {/each}
  </ul>
  {#each items as item}
    {#if activeTabValue == item.value}
      <div
        id="parent"
        class="bg-alsa-gray p-3 w-full"
      >
        <svelte:component this={item.component} />
      </div>
    {/if}
  {/each}
</div>

<style lang="postcss">
  #parent :global(form) {
    @apply flex flex-col bg-white lg:bg-transparent lg:flex-row items-center;
  }

  #parent :global(.form-group) {
    @apply bg-white w-full h-24 flex flex-col p-2;
  }

  #parent :global(.form-group > label) {
    @apply p-2 lg:text-cs-light-gray;
  }

  #parent :global(.form-group > input) {
    @apply w-full h-full p-2 m-0 border border-black rounded lg:border-none focus:outline-none;
  }

  #parent :global(.form-group > select) {
    @apply w-full h-full p-2 m-0 hover:cursor-pointer focus:outline-none;
  }

  #parent :global(.form-group:not(:last-child)) {
    @apply border-r;
  }

  #parent :global(input[type="date"]) {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
  }
</style>
